import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { getStoredRef } from "@/lib/referral";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowRight, Loader2 } from "lucide-react";

export default function BuyButton({ label = "Get Instant Access", className = "btn-cobalt", testId = "buy-button", style, hideIcon = false }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const startCheckout = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !email.includes("@")) { setError("Enter a valid email."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/checkout/create", {
        email,
        origin_url: window.location.origin,
        ref: getStoredRef() || undefined,
      });
      window.location.href = data.url;
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <>
      <button type="button" className={className} style={style} data-testid={testId} onClick={() => setOpen(true)}>
        {label}{!hideIcon && <ArrowRight size={18} style={{ marginLeft: 8, display: "inline", verticalAlign: "middle" }} />}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="card-paper" style={{ maxWidth: 440 }}>
          <DialogHeader>
            <DialogTitle className="font-archivo" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 24 }}>
              Claim Your Spot
            </DialogTitle>
            <DialogDescription className="font-mono-plex" style={{ textTransform: "uppercase", letterSpacing: "0.08em", fontSize: 12 }}>
              The Weekend AI Offer System · $97 one-time
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={startCheckout} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <label className="eyebrow" htmlFor="checkout-email">Your email</label>
            <input
              id="checkout-email"
              data-testid="checkout-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              style={{
                border: "1px solid var(--line)", borderRadius: 10, padding: "13px 14px",
                fontSize: 16, fontFamily: "Inter, sans-serif", background: "#fff",
              }}
            />
            {error && <span style={{ color: "#b00020", fontSize: 14 }} data-testid="checkout-error">{error}</span>}
            <button className="btn-cobalt" type="submit" disabled={loading} data-testid="checkout-submit" style={{ justifyContent: "center" }}>
              {loading ? <Loader2 size={18} className="animate-spin" /> : "Continue to secure checkout"}
            </button>
            <span style={{ fontSize: 12, color: "var(--muted)", textAlign: "center" }}>
              Secure payment via Stripe. You set your password after purchase.
            </span>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
